import React,{Component} from 'react';
import styled, { withTheme } from 'styled-components';
// import {color} from '../../sass-files/variable';
import TopSection from './top-live-games/index';
import BottomSection from './bottom-live-games/index';
import { withAppContext } from 'src/store/initAppContext';
import { theme } from 'styled-tools';

// const {menucolor} = color

class HomeLiveGames extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { theme, app: { brandId } } = this.props;
        return (
            <LiveGamesWrapper>
                <TopSection/>
                <BottomSection/>
            </LiveGamesWrapper>
        )
    }
}

export default withAppContext(withTheme(HomeLiveGames));

const LiveGamesWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    background: ${theme('palette.homeLiveGamesBGColor')};
    padding: 5px;
`;